import { ArrowUp } from 'lucide-react';
import Logo from './Logo';
import { company, navLinks, products } from '../data/content';

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-ink text-gray-400">
      <div className="container-x grid gap-12 pb-10 pt-20 sm:grid-cols-2 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Logo light showTagline />
          <p className="mt-6 max-w-xs text-sm leading-relaxed">
            Design, construction and operational management of water, wastewater treatment and
            water reuse plants.
          </p>
        </div>
        <div className="lg:col-span-2">
          <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white">Explore</h4>
          <ul className="mt-5 space-y-2.5 text-sm">
            {navLinks.map(({ id, label }) => (
              <li key={id}>
                <a href={`#${id}`} className="transition hover:text-white">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white">Products</h4>
          <ul className="mt-5 space-y-2.5 text-sm">
            {products.map((p) => (
              <li key={p.id}>
                <a href={`#product-${p.id}`} className="transition hover:text-white">
                  <span className="mr-2 font-display font-semibold text-brand-500">{p.code}</span>
                  {p.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white">Reach us</h4>
          <address className="mt-5 space-y-2.5 text-sm not-italic">
            <p>{company.address}</p>
            <p>
              <a href={`tel:${company.phoneRaw}`} className="text-white hover:text-brand-400">
                {company.phone}
              </a>
            </p>
            <p>
              <a href={`mailto:${company.email}`} className="break-all hover:text-white">
                {company.email}
              </a>
            </p>
          </address>
        </div>
      </div>

      <div className="container-x relative">
        <div className="select-none font-display text-[19vw] font-bold leading-[0.8] tracking-tighter text-white/[0.04] lg:text-[16.5rem]">
          AGNISAFE
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x flex flex-col items-start gap-4 py-6 text-xs sm:flex-row sm:items-center sm:justify-between">
          <span>
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </span>
          <a href="#home" className="inline-flex items-center gap-2 font-semibold text-white hover:text-brand-400">
            Back to top <ArrowUp className="h-4 w-4" />
          </a>
        </div>
      </div>
    </footer>
  );
}
